<ng-container *transloco="let t; prefix: 'edit-series-modal'">

  <app-edit-modal-shell
    translocoPrefix="edit-series-modal"
    [title]="t('title', {seriesName: this.series().name})"
    (save)="save()"
    (close)="close()"
    [activeTabId]="activeTabId()"
    (activeTabIdChange)="changeTab($event)"
    [field]="formGroup"
  >

    @if (series()) {
      <ng-template [appEditTab]="Tabs.General">
        <div class="row">
          <div class="mb-3" style="width: 100%">
            <app-setting-item [title]="t('name-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.name">
              <ng-template #view>
                <app-lockable-field [(locked)]="locks.name">
                  <input class="form-control" [formField]="formGroup.name" type="text"
                         [appFormField]="formGroup.name">
                </app-lockable-field>
              </ng-template>
            </app-setting-item>
          </div>
        </div>

        <div class="row">
          <div class="mb-3" style="width: 100%">
            <app-setting-item [title]="t('sort-name-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.sortName">
              <ng-template #view>
                <app-lockable-field [(locked)]="locks.sortName">
                  <input class="form-control" [formField]="formGroup.sortName" type="text"
                         [appFormField]="formGroup.sortName">
                </app-lockable-field>
              </ng-template>
            </app-setting-item>
          </div>
        </div>

        <div class="row">
          <div class="mb-3" style="width: 100%">
            <app-setting-item [title]="t('localized-name-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.localizedName">
              <ng-template #view>
                <app-lockable-field [(locked)]="locks.localizedName">
                  <input class="form-control" [formField]="formGroup.localizedName" type="text"
                         [appFormField]="formGroup.localizedName">
                </app-lockable-field>
              </ng-template>
            </app-setting-item>
          </div>
        </div>

        @if (metadata()) {
          <div class="row">
            <div class="mb-3" style="width: 100%">
              <app-setting-item [title]="t('summary-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.metadata.summary">
                <ng-template #view>
                  <app-lockable-field [(locked)]="metadataLocks.summary">
                    <textarea class="form-control" [formField]="formGroup.metadata.summary" [appFormField]="formGroup.metadata.summary" rows="4"></textarea>
                  </app-lockable-field>
                </ng-template>
              </app-setting-item>
            </div>
          </div>
        }
      </ng-template>
    }

    @if (series() && metadata()) {

      <ng-template [appEditTab]="Tabs.Metadata">
        <div class="row">
          <div class="col-lg-8 col-md-12 pe-2">
            <div class="mb-3">
              <app-setting-item [title]="t('language-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.metadata.language">
                <ng-template #view>
                  <app-typeahead (selectedData)="updateLanguage($event)" [config]="languageTypeaheadSettings()"
                                 [(locked)]="metadataLocks.language">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.title}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.title}} ({{item.isoCode}})
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            </div>
          </div>
          <div class="col-lg-4 col-md-12">
            <div class="mb-3" style="width: 100%">
              <app-setting-item [title]="t('release-year-label')" [toggleOnViewClick]="false" [showEdit]="false"
                                [control]="formGroup.metadata.releaseYear" [validations]="{
                                  pattern: t('release-year-validation')
                                }">
                <ng-template #view>
                  <app-lockable-field [(locked)]="metadataLocks.releaseYear">
                    <input type="number" inputmode="numeric" class="form-control" [formField]="formGroup.metadata.releaseYear"
                           [appFormField]="formGroup.metadata.releaseYear">
                  </app-lockable-field>
                </ng-template>
              </app-setting-item>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <app-setting-item [title]="t('genres-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.metadata.genres">
                <ng-template #view>
                  <app-typeahead (selectedData)="updateGenres($event)" [config]="genreTypeaheadSettings()"
                                 [(locked)]="metadataLocks.genres">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.title}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.title}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <app-setting-item [title]="t('tags-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.metadata.tags">
                <ng-template #view>
                  <app-typeahead (selectedData)="updateTags($event)" [config]="tagsTypeaheadSettings()"
                                 [(locked)]="metadataLocks.tags">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.title}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.title}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              <app-setting-item [title]="t('age-rating-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.metadata.ageRating">
                <ng-template #view>
                  <app-lockable-field [(locked)]="metadataLocks.ageRating">
                    <app-setting-select [options]="ageRatings()" [formField]="formGroup.metadata.ageRating" />
                  </app-lockable-field>
                </ng-template>
              </app-setting-item>
            </div>
          </div>
          <div class="col-lg-6 col-md-12">
            <div class="mb-3">
              <app-setting-item [title]="t('publication-status-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.metadata.publicationStatus">
                <ng-template #view>
                  <app-lockable-field [(locked)]="metadataLocks.publicationStatus">
                    <app-setting-select [options]="publicationStatuses()" [formField]="formGroup.metadata.publicationStatus">
                      <ng-template #template let-ps>
                        {{ ps | publicationStatus }}
                      </ng-template>
                    </app-setting-select>
                  </app-lockable-field>
                </ng-template>
              </app-setting-item>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template [appEditTab]="Tabs.ExternalMetadataIds">
        @let providerOverride = formGroup.metadataProviderOverride().value();
        <div class="row g-0 mb-4">
          <app-setting-item [title]="t('metadata-provider-override-label')" [subtitle]="t('metadata-provider-override-tooltip')"
                            [canEdit]="true" [control]="formGroup.metadataProviderOverride">
            <ng-template #view>
              @if (providerOverride === '') {
                {{t('metadata-provider-override-default')}}
              } @else {
                {{parseInt(providerOverride, 10) | metadataProviderTitle}}
              }
            </ng-template>
            <ng-template #edit>
              <select class="form-select" [formField]="formGroup.metadataProviderOverride"
                      [appFormField]="formGroup.metadataProviderOverride">
                <option [value]="''">{{ t('metadata-provider-override-default') }}</option>
                @for (metadataProvider of AllMetadataProviders; track metadataProvider) {
                  <option [value]="metadataProvider">{{ metadataProvider | metadataProviderTitle }}</option>
                }
              </select>
            </ng-template>
          </app-setting-item>
        </div>
        <app-edit-external-metadata-form [field]="formGroup"/>
      </ng-template>
    }

    @if (series() && metadata()) {
      <ng-template [appEditTab]="Tabs.People">
        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Writer); as settings) {
              <app-setting-item [title]="t('writer-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Writer)" [config]="settings"
                                 [(locked)]="personLocks.writerLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>
        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.CoverArtist); as settings) {
              <app-setting-item [title]="t('cover-artist-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.CoverArtist)" [config]="settings"
                                 [(locked)]="personLocks.coverArtistLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>


        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Publisher); as settings) {
              <app-setting-item [title]="t('publisher-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Publisher)" [config]="settings"
                                 [(locked)]="personLocks.publisherLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>

        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Imprint); as settings) {
              <app-setting-item [title]="t('imprint-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Imprint)" [config]="settings"
                                 [(locked)]="personLocks.imprintLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>

        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Penciller); as settings) {
              <app-setting-item [title]="t('penciller-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Penciller)" [config]="settings"
                                 [(locked)]="personLocks.pencillerLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>


        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Letterer); as settings) {
              <app-setting-item [title]="t('letterer-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Letterer)" [config]="settings"
                                 [(locked)]="personLocks.lettererLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>
        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Inker); as settings) {
              <app-setting-item [title]="t('inker-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Inker)" [config]="settings"
                                 [(locked)]="personLocks.inkerLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>



        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Editor); as settings) {
              <app-setting-item [title]="t('editor-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Editor)" [config]="settings"
                                 [(locked)]="personLocks.editorLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>
        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Colorist); as settings) {
              <app-setting-item [title]="t('colorist-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Colorist)" [config]="settings"
                                 [(locked)]="personLocks.coloristLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>

        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Translator); as settings) {
              <app-setting-item [title]="t('translator-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Translator)" [config]="settings"
                                 [(locked)]="personLocks.translatorLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>

        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Character); as settings) {
              <app-setting-item [title]="t('character-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Character)" [config]="settings"
                                 [(locked)]="personLocks.characterLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>

        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Team); as settings) {
              <app-setting-item [title]="t('team-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Team)" [config]="settings"
                                 [(locked)]="personLocks.teamLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>

        <div class="row">
          <div class="mb-3">
            @if (getPersonsSettings(PersonRole.Location); as settings) {
              <app-setting-item [title]="t('location-label')" [toggleOnViewClick]="false" [showEdit]="false">
                <ng-template #view>
                  <app-typeahead (selectedData)="updatePerson($event, PersonRole.Location)" [config]="settings"
                                 [(locked)]="personLocks.locationLocked">
                    <ng-template #badgeItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                    <ng-template #optionItem let-item let-position="idx">
                      {{item.name}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            }
          </div>
        </div>
      </ng-template>
    }

    @if (series() && metadata()) {
      <ng-template [appEditTab]="Tabs.WebLinks">
        <p>{{t('web-link-description')}}</p>
        <app-edit-list [items]="weblinks()" [label]="t('web-link-label')" (updateItems)="updateWeblinks($event)" />
      </ng-template>
    }

    @if (series()) {
     <ng-template [appEditTab]="Tabs.CoverImage">
       <p class="alert alert-warning" role="alert">
         {{t('cover-image-description')}}
       </p>
       <app-cover-image-chooser [config]="chooserConfig()" (coverChanged)="handleCoverChanged($event)" (resetClicked)="handleReset()" />
     </ng-template>
    }

    @if(series(); as s) {
      <ng-template [appEditTab]="Tabs.Related">
        <app-edit-series-relation [series]="s" [save]="saveNestedComponents"/>
      </ng-template>
    }

    @if (series()) {
     <ng-template [appEditTab]="Tabs.Info">
       <div class="row">
         <div class="col-lg-6 col-md-12 pe-2">
           <div class="mb-3">
             <app-setting-item [title]="t('library-title')" [toggleOnViewClick]="false" [showEdit]="false">
               <ng-template #view>
                 {{libraryName() | sentenceCase}}
               </ng-template>
             </app-setting-item>
           </div>
         </div>
         <div class="col-lg-6 col-md-12 pe-2">
           <div class="mb-3">
             <app-setting-item [title]="t('format-title')" [toggleOnViewClick]="false" [showEdit]="false">
               <ng-template #view>
                 {{series().format | mangaFormat}}
               </ng-template>
             </app-setting-item>
           </div>
         </div>
       </div>

       <div class="row">
         <div class="col-lg-6 col-md-12 pe-2">
           <div class="mb-3">
             <app-setting-item [title]="t('folder-path-title')" [subtitle]="t('folder-path-tooltip')" [toggleOnViewClick]="false" [showEdit]="false">
               <ng-template #view>
                 {{series().folderPath | defaultValue}}
               </ng-template>
             </app-setting-item>
           </div>
         </div>
         <div class="col-lg-6 col-md-12 pe-2">
           <div class="mb-3">
             <app-setting-item [title]="t('lowest-folder-path-title')" [subtitle]="t('lowest-folder-path-tooltip')" [toggleOnViewClick]="false" [showEdit]="false">
               <ng-template #view>
                 {{series().lowestFolderPath | defaultValue}}
               </ng-template>
             </app-setting-item>
           </div>
         </div>
       </div>

       @if (metadata(); as mdata) {
         <div class="row">
           <div class="col-lg-6 col-md-12 pe-2">
             <div class="mb-3">
               <app-setting-item [title]="t('max-items-title')" [subtitle]="t('highest-count-tooltip')" [toggleOnViewClick]="false" [showEdit]="false">
                 <ng-template #view>
                   @if (mdata.maxCount === LooseLeafOrDefaultNumber) {
                     {{t('no-data')}}
                   } @else {
                     {{mdata.maxCount}}
                   }
                 </ng-template>
               </app-setting-item>
             </div>
           </div>
           <div class="col-lg-6 col-md-12 pe-2">
             <div class="mb-3">
               <app-setting-item [title]="t('total-items-title')" [subtitle]="t('max-issue-tooltip')" [toggleOnViewClick]="false" [showEdit]="false">
                 <ng-template #view>
                   {{mdata.totalCount}}
                 </ng-template>
               </app-setting-item>
             </div>
           </div>
         </div>

         <div class="row">
           <div class="col-lg-6 col-md-12 pe-2">
             <div class="mb-3">
               <app-setting-item [title]="t('publication-status-title')" [toggleOnViewClick]="false" [showEdit]="false">
                 <ng-template #view>
                   {{mdata.publicationStatus | publicationStatus}}
                 </ng-template>
               </app-setting-item>
             </div>
           </div>
           <div class="col-lg-6 col-md-12 pe-2">
             <div class="mb-3">
               <app-setting-item [title]="t('size-title')" [toggleOnViewClick]="false" [showEdit]="false">
                 <ng-template #view>
                   {{size() | bytes}}
                 </ng-template>
               </app-setting-item>
             </div>
           </div>
         </div>
       }

       <div class="row">
         <div class="col-lg-6 col-md-12 pe-2">
           <div class="mb-3">
             <app-setting-item [title]="t('created-title')" [toggleOnViewClick]="false" [showEdit]="false">
               <ng-template #view>
                 {{series().created | utcToLocalTime:'shortDate'}}
               </ng-template>
             </app-setting-item>
           </div>
         </div>
         <div class="col-lg-6 col-md-12 pe-2">
           <div class="mb-3">
             <app-setting-item [title]="t('last-added-title')" [toggleOnViewClick]="false" [showEdit]="false">
               <ng-template #view>
                 {{series().lastChapterAdded | defaultDate | timeDifference}}
               </ng-template>
             </app-setting-item>
           </div>
         </div>
       </div>

       <div class="row">
         <div class="col-lg-6 col-md-12 pe-2">
           <div class="mb-3">
             <app-setting-item [title]="t('last-scanned-title')" [toggleOnViewClick]="false" [showEdit]="false">
               <ng-template #view>
                 {{series().lastFolderScanned | defaultDate | timeDifference}}
               </ng-template>
             </app-setting-item>
           </div>
         </div>
         <div class="col-lg-6 col-md-12 pe-2">
           <div class="mb-3">
             <app-setting-item [title]="t('last-read-title')" [toggleOnViewClick]="false" [showEdit]="false">
               <ng-template #view>
                 {{series().lastChapterAdded | defaultDate | timeDifference}}
               </ng-template>
             </app-setting-item>
           </div>
         </div>
       </div>

       <div class="row">
         <div class="col-lg-6 col-md-12 pe-2">
           <div class="mb-3">
             <app-setting-item [title]="t('total-pages-title')" [toggleOnViewClick]="false" [showEdit]="false">
               <ng-template #view>
                 {{series().pages | number}}
               </ng-template>
             </app-setting-item>
           </div>
         </div>
         <div class="col-lg-6 col-md-12 pe-2">
           <div class="mb-3">
             <app-setting-item [title]="t('total-words-title')" [toggleOnViewClick]="false" [showEdit]="false">
               <ng-template #view>
                 {{series().wordCount | number}}
               </ng-template>
             </app-setting-item>
           </div>
         </div>
       </div>

       <h4>{{t('volumes-title')}}</h4>
       @if (isLoadingVolumes()) {
         <div class="spinner-border text-primary" role="status">
           <span class="visually-hidden">{{t('loading')}}</span>
         </div>
       } @else {
         <ul class="list-unstyled">
           @for (row of volumeRows(); track row.volume.id) {
             @let volume = row.volume;
             <li class="d-flex my-4">
               <app-image class="me-3" style="width: 4.625rem;" width="74px" [imageUrl]="imageService.getVolumeCoverImage(volume.id)" />
               <div class="flex-grow-1">
                 <h5 class="mt-0 mb-1">{{formatVolumeName(volume)}}</h5>
                 <div>
                   <div class="row">
                     <div class="col">
                       {{t('added-title')}} {{volume.createdUtc | utcToLocalTime | defaultDate}}
                     </div>
                     <div class="col">
                       {{t('last-modified-title')}} {{volume.lastModifiedUtc | utcToLocalTime:'short' | defaultDate}}
                     </div>
                   </div>
                   <div class="row">
                     <div class="col">
                       <button type="button" class="btn btn-outline-primary"  (click)="toggleVolume(volume.id)"
                               [attr.aria-expanded]="expandedVolumes().has(row.volume.id)" [disabled]="!accountService.hasAdminRole()">
                         {{t('view-files')}}
                       </button>
                     </div>
                     <div class="col">
                       {{t('pages-title')}} {{volume.pages}}
                     </div>
                   </div>

                   <div [ngbCollapse]="!expandedVolumes().has(row.volume.id)">
                     <ul class="list-group mt-2">
                       @for(file of row.files; track file.id) {
                         <li class="list-group-item">
                           <span>{{file.filePath}}</span>
                           <div class="row">
                             <div class="col">
                               {{t('chapter-title')}} {{file.chapter}}
                             </div>
                             <div class="col">
                               {{t('pages-title')}} {{file.pages}}
                             </div>
                             <div class="col">
                               {{t('format-title')}} <span class="badge badge-secondary">{{file.format | mangaFormat}}</span>
                             </div>
                           </div>
                         </li>
                       }
                     </ul>
                   </div>
                 </div>
               </div>
             </li>
           }
         </ul>
       }
     </ng-template>
    }

    <ng-template [appEditTab]="Tabs.Tasks">
      @for(task of tasks(); track task.action) {
        @if (accountService.canCurrentUserInvokeAction(task.action)) {
          <div class="mt-3 mb-3">
            <app-setting-button [subtitle]="task.description">
              <button type="button" class="btn btn-{{task.action === Action.Delete ? 'danger' : 'secondary'}} btn-sm mb-2" (click)="runTask(task)">{{task.title}}</button>
            </app-setting-button>
          </div>
        }
      }
    </ng-template>

  </app-edit-modal-shell>

</ng-container>
